// Fetch profile
export const FETCH_PROFILE_REQUESTED = 'profile/FETCH_PROFILE_REQUESTED';
export const FETCH_PROFILE_SUCCESS = 'profile/FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'profile/FETCH_PROFILE_FAILURE';

// delete
export const DELETE_ENTRY_REQUESTED = 'profile/DELETE_ENTRY_REQUESTED';
export const DELETE_ENTRY_SUCCESS = 'profile/DELETE_ENTRY_SUCCESS';
export const DELETE_ENTRY_FAILURE = 'profile/DELETE_ENTRY_FAILURE';

// description
export const UPDATE_DESCRIPTION_REQUESTED = 'profile/UPDATE_DESCRIPTION_REQUESTED';
export const UPDATE_DESCRIPTION_SUCCESS = 'profile/UPDATE_DESCRIPTION_SUCCESS';
export const UPDATE_DESCRIPTION_FAILURE = 'profile/UPDATE_DESCRIPTION_FAILURE';

// share content
export const SHARE_CONTENT_REQUESTED = 'profile/SHARE_CONTENT_REQUESTED';
export const SHARE_CONTENT_SUCCESS = 'profile/SHARE_CONTENT_SUCCESS';
export const SHARE_CONTENT_FAILURE = 'profile/SHARE_CONTENT_FAILURE';
export const SHARE_CONTENT_COMPLETE = 'profile/SHARE_CONTENT_COMPLETE';

// Fetch shared content
export const FETCH_SHARED_CONTENT_REQUESTED = 'profile/FETCH_SHARED_CONTENT_REQUESTED';
export const FETCH_SHARED_CONTENT_SUCCESS = 'profile/FETCH_SHARED_CONTENT_SUCCESS';
export const FETCH_SHARED_CONTENT_ERROR = 'profile/FETCH_SHARED_CONTENT_ERROR';